import Vue from 'vue'
import API from '@/api/callApi.js'
import endpoints from '@/api/endpoints';

export default {
    namespaced : true,
    state : {
    	personal_message : {
    		data : null,
    		loaded : false,
    		loading : false,
    		upserting : false,
    		error : null
    	}
    },
    mutations : {

		setPersonalMessageData (state, value) {

			state.personal_message.data = value;

            if (state.personal_message.data === null) {
                Vue.set(state.personal_message, 'data', {});
                
            }

			if (value.optin === null) {
				Vue.set(state.personal_message.data, 'optin', {
                    id : null,
                    establishment_id : "",
                    sms_content : null,
                    email_content : null
                });	
			}
            else {
                Vue.set(state.personal_message.data, 'optin', value.optin);	
            }

            if (value.optout === null) {
				Vue.set(state.personal_message.data, 'optout', {
                    id : null,
                    establishment_id : "",
                    sms_content : null,
                    email_content : null
                });
			}
            else {
                Vue.set(state.personal_message.data, 'optout', value.optout);
            }
		},
		setPersonalMessageDataField (state, params) {
            state.personal_message.data[params.type][params.field] = params.value;
		},
		setPersonalMessageLoaded (state, value) {
			state.personal_message.loaded = value;
		},
		setPersonalMessageLoading (state, value) {
			state.personal_message.loading = value;
		},
		setPersonalMessageError (state, value) {
			state.personal_message.error = value;
		},
		setPersonalMessageUpserting (state, value) {
			state.personal_message.upserting = value;
		}

    },
    actions : {

    	/*
		** Récupère les données du portail, renvoie nul si pas de portail
		*/

    	loadPersonalMessageData ({ state, commit }, { parameters }) {

    		if (state.personal_message.loaded || state.personal_message.loading) {
    			return;
    		}

    		commit('setPersonalMessageLoading', true);

    		let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.loadPersonalMessage, {
    			establishment_id : parameters.establishment_id
    		});

    		API.makeGet(url, null, true)
    		.then ( response => {
    			commit('setPersonalMessageLoaded', true);
    			commit('setPersonalMessageData', response.data.payload);
    		})
    		.catch ( response => {
    			commit('ui/triggerAlert', {
	    				type : 'error',
	    				msg : "Une erreur est survenue lors du chargement du message personnel."
    				}, { root : true });
    		})
    		.finally ( response => {
    			commit('setPersonalMessageLoading', false);
    		});

    	},

    	/*
		** Crée ou met à jour le Personal message
		*/

		upsertPersonalMessageData ({ state, commit }, { success, parameters }) {
			if (state.personal_message.upserting) {
				return;
			}

			commit('setPersonalMessageUpserting', true);

			let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.upsertPersonalMessage, {
                establishment_id : parameters.establishment_id
            });

            // console.info('url', url);
            // console.info('perso', endpoints.endpoints.upsertPersonalMessage);

			API.makePost(url, 
                {
                    'optin' : JSON.stringify(parameters.optin),
                    'optout' : JSON.stringify(parameters.optout),
                },
                true)
    		.then ( response => {
			
            success();

            // 	commit('ui/triggerAlert', {
			// 		type : 'success',
			// 		msg : "Votre message personnel a bien été mise à jour."
			// 	}, { root : true });

    		})
    		.catch ( response => {
    			commit('ui/triggerAlert', {
	    				type : 'error',
	    				msg : "Une erreur est survenue lors de la mise à jour du message personnel."
    				}, { root : true });
    		})
    		.finally ( response => {
    			commit('setPersonalMessageUpserting', false);
    		});

		}
    }
};
